import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ComingSoon from "@/pages/ComingSoon";
import LegalPage from "@/pages/LegalPage";

const COMING_SOON = (process.env.REACT_APP_COMING_SOON || "").toLowerCase() === "true";

function Shell() {
  const location = useLocation();
  const isComingSoon = COMING_SOON && location.pathname === "/";
  const hideChrome = isComingSoon || location.pathname.startsWith("/admin");

  return (
    <div className={`App ${isComingSoon ? "" : "grain"} relative`}>
      {!hideChrome && <Navbar />}
      <Routes>
        {/* When coming soon flag is on, "/" shows ComingSoon and the real site moves to /preview & /site */}
        <Route path="/" element={COMING_SOON ? <ComingSoon /> : <Home />} />
        <Route path="/preview" element={<Home />} />
        <Route path="/site" element={<Home />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/legal/privacidad" element={<LegalPage kind="privacy" />} />
        <Route path="/legal/aviso-legal" element={<LegalPage kind="legal" />} />
      </Routes>
      {!hideChrome && <Footer />}
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#2E402B",
            color: "#F5F3ED",
            border: "1px solid rgba(245,243,237,0.15)",
            borderRadius: 0,
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 12,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
